/**
 * Paystack issues key pairs per environment: pk_test_/sk_test_ for test mode
 * and pk_live_/sk_live_ for live mode. The prefix is the only reliable
 * client-side signal of which environment a school has configured.
 */
export function isPaystackTestKey(key?: string | null): boolean {
  return /^(pk|sk)_test_/.test(key ?? '');
}
